
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke144aRequest, Sgke144aResponse, Sgke144aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke144aService {

  /**
   * コンストラクタ
   * @param {Sgke144aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke144aService
   */
  constructor(
    public service: Sgke144aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE144A_手数料報告登録（訂正）APIAPI呼び出し
   * @param {Sgke144aRequest} request 
   * @returns {Observable<Sgke144aResponse>}
   * @memberof UsedSgke144aService
   */
  public doSgke144a(request: Sgke144aRequest): Observable<Sgke144aResponse> {
    return this.service.sgke144aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE144A');
          return throwError(err.message);
        })
      );
  }

}
